// Staff

$(function () {
  $('.jsZpmvBlockStaffCarousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    navText:[
      "<svg class=\"icon-chevron-left\"><use xlink:href=\"#icon-chevron-left\"></use></svg>",
      "<svg class=\"icon-chevron-right\"><use xlink:href=\"#icon-chevron-right\"></use></svg>"
    ],
    dots: false,
    items: 3,
    smartSpeed: 500,
    autoplay: false,
    autoplayTimeout: 6000,
    autoplayHoverPause: true,
    responsive:{
      0:{
          items:1
      },
      576:{
          items:2
      },
      1000:{
          items:3
      }
    }
  });
})
